
import ResumeItem from './ResumeItem';
import { CompanyMovementsTotalizerData } from '@/features/privateCompanies/types/companyMovementsTotalizer.type';
import { companyResumeItems } from '@/features/privateCompanies/constants/companyMovementsTotalizer.constants';
interface ResumeListProps {
  data: CompanyMovementsTotalizerData;
  requiresAttention?: boolean
}

const ResumeList = ({ data, requiresAttention = false }: ResumeListProps) => {
  return (
    <div className="flex gap-6">
      {companyResumeItems(data)
        .filter((item) => requiresAttention ? item.value : (item.value && !item.showWhenRequireAttentionIsActive))
        .map((itemConfig, index) => <ResumeItem key={index} {...itemConfig}/>)
      }
    </div>
  )
}

export default ResumeList